<template>
  <div class="d-flex flex-wrap justify-content-between align-items-center">
    <b-button
      variant="gradient-secondary"
      class="d-flex align-items-center"
      @click="addFaqs"
    >
      <span class="mr-1">پرسش و پاسخ</span>
      <feather-icon icon="PlusIcon" />
    </b-button>
    <div class="w-100">
      <draggable
        v-model="faqs"
        class="list-group list-group-flush cursor-move"
        tag="ul"
      >
        <b-list-group-item
          v-for="(faq, index) in faqs"
          :key="'faq-' + index"
          tag="li"
        >
          <div>
            <div class="d-flex justify-content-between">
              <span class="mr-2 font-weight-bold">{{ index + 1 }}.</span>
              <b-form-group label-for="add-faq-active">
                <b-form-checkbox
                  v-model="faq.active"
                  name="check-active"
                  switch
                  inline
                >
                  وضعیت
                </b-form-checkbox>
              </b-form-group>
            </div>
            <b-form-group label="پرسش" label-for="question" class="w-100">
              <validation-provider
                #default="{ errors }"
                name="question"
                vid="question"
                rules="required"
              >
                <b-form-input
                  autocomplete="on"
                  id="question"
                  v-model="faq.question"
                  name="question"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="پاسخ" label-for="answer" class="w-100">
              <validation-provider
                #default="{ errors }"
                name="answer"
                vid="answer"
                rules="required"
              >
                <b-form-input
                  autocomplete="on"
                  id="answer"
                  v-model="faq.answer"
                  name="answer"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="d-flex justify-content-between w-100">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              size="sm"
              class="btn-icon rounded-circle"
              @click="removeFaq(index)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-list-group-item>
      </draggable>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BBadge,
  BListGroupItem,
  BFormRadio,
  BFormCheckbox,
} from "bootstrap-vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Ripple from "vue-ripple-directive";
import draggable from "vuedraggable";
import Editor from "@/@core/components/editor/Editor.vue";

export default {
  components: {
    BButton,
    SelectBox,
    BFormGroup,
    BListGroupItem,
    ValidationProvider,
    ValidationObserver,
    BFormRadio,
    BFormInput,
    BBadge,
    draggable,
    Editor,
    BFormCheckbox,
  },
  props: {
    faqs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      required,
    };
  },
  watch: {
    faqs: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  directives: {
    Ripple,
  },
  methods: {
    addFaqs() {
      this.faqs.push({ active: 0 });
    },
    removeFaq(index) {
      this.faqs.splice(index, 1);
    },
  },
};
</script>
